import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'styles'

/**
 * The credit price shown at the end of a button ("5 ◎"). One element, so the button's own gap spaces it
 * from the label, and the number stays next to its icon. The font size is pinned because MUI's Button
 * enlarges the first element of its endIcon (it expects an icon there), which would blow up the number.
 */
const CreditCost = ({ cost }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 'inherit', lineHeight: 'inherit' }}>
    {cost}
    <Icon folder="icons" fileName="credits.svg" style={{ display: 'flex' }} />
  </span>
)

CreditCost.propTypes = {
  cost: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default CreditCost
